import { render } from "./footer.vue?vue&type=template&id=03efda02&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=03efda02&lang=scss&scoped=true"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03efda02"]])

export default __exports__